"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ExpandableFooter = _ref => {
  let title = _ref.title,
    open = _ref.open,
    children = _ref.children,
    onClick = _ref.onClick,
    _ref$gradient = _ref.gradient,
    gradient = _ref$gradient === void 0 ? 'linear-gradient(90deg, #441D99 0%, #714FFF 100%)' : _ref$gradient;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
    sx: {
      position: 'fixed',
      bottom: 0,
      zIndex: 1200,
      width: '100%'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        maxWidth: 440
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        onClick: onClick,
        style: {
          position: 'relative',
          top: 19,
          left: '46%',
          transition: 'transform 0.3s'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
          width: "32",
          height: "32",
          viewBox: "0 0 32 32",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            filter: "url(#filter0_d_9406_396)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              x: "4",
              width: "24",
              height: "24",
              rx: "12",
              fill: "#FDFBF9",
              "shape-rendering": "crispEdges"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              x: "4.5",
              y: "0.5",
              width: "23",
              height: "23",
              rx: "11.5",
              stroke: "#D2D3DD",
              "shape-rendering": "crispEdges"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M20.59 15L16 10.6973L11.41 15L10 13.6754L16 8.03867L22 13.6754L20.59 15Z",
              fill: "#714FFF"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("filter", {
              id: "filter0_d_9406_396",
              x: "0",
              y: "0",
              width: "32",
              height: "32",
              filterUnits: "userSpaceOnUse",
              "color-interpolation-filters": "sRGB",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("feFlood", {
                "flood-opacity": "0",
                result: "BackgroundImageFix"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feOffset", {
                dy: "4"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feGaussianBlur", {
                stdDeviation: "2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feComposite", {
                in2: "hardAlpha",
                operator: "out"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
                mode: "normal",
                in2: "BackgroundImageFix",
                result: "effect1_dropShadow_9406_396"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_dropShadow_9406_396",
                result: "shape"
              })]
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        sx: {
          cursor: 'pointer',
          background: gradient,
          color: '#fff',
          textAlign: 'center',
          py: 2,
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          variant: "h6",
          fontWeight: 600,
          sx: {
            fontSize: '1rem'
          },
          children: title
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Collapse, {
        in: open,
        timeout: "auto",
        unmountOnExit: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
          sx: {
            backgroundColor: '#fff',
            py: 3,
            maxHeight: '60vh',
            overflowY: 'auto'
          },
          children: children
        })
      })]
    })
  });
};
var _default = exports.default = ExpandableFooter;